import Vue from 'vue';

import Tournament from '@core/models/struct/Tournament';
import StoreUtil from '@store/StoreUtil';

import type {
    Getters,
    FavouritesState,
} from './types';

const TOGGLE_FILTERED_TOURNAMENT = 'TOGGLE_FILTERED_TOURNAMENT';
const CLEAR_FILTERED_TOURNAMENTS = 'CLEAR_FILTERED_TOURNAMENTS';

const getters: Getters = {
    shownTournamentIds(_state, getters, _rootState, rootGetters) {
        const userFavouritedTournaments = rootGetters['ui/user/preferences/tournamentIds'];
        const filteredTournamentsIds = getters.filteredTournamentsIds;

        return Object.keys(filteredTournamentsIds).length === 0
            ? userFavouritedTournaments : userFavouritedTournaments.filter((id) => filteredTournamentsIds[id]);
    },
    filteredTournamentEvents(_state, getters, _rootState, rootGetters) {
        const allEvents = rootGetters['data/sportOffer/events'];
        const shownTournamentIds = getters.shownTournamentIds;

        return allEvents.filter((event) =>
            shownTournamentIds.find((id: number) => id === event.tournamentId)
                && !event.isFinished() && !event.isStopped());
    },
    filteredTournamentsWithNoEvents(_state, getters, _rootState, rootGetters) {
        const userFavouritedTournaments = rootGetters['ui/user/preferences/tournaments'];
        const filteredTournamentEvents = getters.filteredTournamentEvents;
        const shownTournamentIds = getters.shownTournamentIds;

        const emptyFilteredTournamentIds = shownTournamentIds.filter((id) => !filteredTournamentEvents.find((event) => event.tournamentId === id));

        return userFavouritedTournaments.filter((tournament) => emptyFilteredTournamentIds.includes(tournament.id));
    },
    filteredTournamentsIds(state) {
        return state.filteredTournamentsIds;
    },
};

const store = {
    getters,
    namespaced: true,
    state: {
        filteredTournamentsIds: {},
    },
    mutations: {
        [TOGGLE_FILTERED_TOURNAMENT]: (state: FavouritesState, tournamentId: Tournament['id']) => {
            if (state.filteredTournamentsIds[tournamentId]) {
                Vue.delete(state.filteredTournamentsIds, tournamentId);
            } else {
                Vue.set(state.filteredTournamentsIds, tournamentId, true);
            }
        },
        [CLEAR_FILTERED_TOURNAMENTS]: (state: FavouritesState) => {
            state.filteredTournamentsIds = {};
        },
    },
    actions: {
        toggleFilteredTournament: StoreUtil.createSimpleMutatorAction(TOGGLE_FILTERED_TOURNAMENT),
        clearFilteredTournaments: StoreUtil.createSimpleMutatorAction(CLEAR_FILTERED_TOURNAMENTS),
    },
};

export { FavouritesState };
export type FavouritesStore = typeof store;

export default store;
